/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/prefer-default-export */
import { IcoMoon } from '@usap/uicomponents'
import styled from 'styled-components'

const SharedContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
`

const SharedTextStyles = styled.span`
  color: #3e3e47;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-style: normal;
  font-weight: 400;
`

export const StyledDrawerContainer = styled(SharedContainerStyles)`
  gap: 20px;
  padding: 20px 16px;
`

export const StyledLogoContainer = styled(SharedContainerStyles)`
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const StyledCarPartsLogo = styled(IcoMoon)`
  width: 170px;
  height: 26px;
`

export const StyledPlusText = styled(SharedTextStyles)`
  color: #282832;
  font-size: 20px;
`

export const StyledProtectAutoPartText = styled(SharedTextStyles)`
  font-size: 20px;
  ${props => props.theme.mediaQuery.down('mobile-portrait')} {
    font-size: 18px;
    line-height: 165%;
  }
`

export const StyledCoverageContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;

  margin-block-end: 0;
  padding-left: 28px;
  margin-top: 0px;
`

// Coverage, Why Choose Extend,
export const StyledText = styled(SharedTextStyles)`
  font-size: 16px;
  font-weight: 500;
  margin-left: -18px;
  margin-bottom: 4px;
`

export const StyledBulletPointText = styled.li`
  color: #3e3e47;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  margin-block: 5px;

  ${props => props.theme.mediaQuery.down('mobile-portrait')} {
    font-size: 14px;
  }
`

export const StyledLinkAndLogoContainer = styled(SharedContainerStyles)`
  flex-direction: row;
  justify-content: space-between;
`

export const StyledDivider = styled.div`
  background-color: #d4d4d6;
  height: 1px;
`

export const StyledReasonsContainer = styled(SharedContainerStyles)`
  gap: 16px;
`
export const StyledReasonsHeading = styled(SharedTextStyles)`
  font-size: 16px;
  font-weight: 500;
`

export const StyledReasonsText = styled(SharedTextStyles)`
  color: #282832;
  font-size: 16px;

  ${props => props.theme.mediaQuery.down('mobile-portrait')} {
    font-size: 14px;
  }
`

export const StyledIconAndReasonContainer = styled(SharedContainerStyles)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
`
